import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Select } from '~components/react-select';

const useStyles = makeStyles({
  root: {
    marginBottom: 16,
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const YEAR_SELECT_RANGE = 100;

const defaultGetYears = (date) => {
  const currentYear = date.getFullYear();
  const years = [];
  for (let i = currentYear - YEAR_SELECT_RANGE; i <= currentYear + YEAR_SELECT_RANGE; i += 1) {
    years.push(i);
  }
  return years;
};

const CaptionSelect = React.forwardRef((props, ref) => {
  const { date, localeUtils, onChange, getYears = defaultGetYears } = props;

  const handleSelectChange = (type) => ({ value }) => {
    if (type === 'month') {
      onChange(new Date(date.getFullYear(), value));
    } else if (type === 'year') {
      onChange(new Date(value, date.getMonth()));
    }
  };

  const monthOptions = useMemo(
    () => localeUtils.getMonths().map((month, idx) => ({ value: idx, label: month })),
    [localeUtils]
  );
  const yearOptions = useMemo(() => getYears(date).map((year) => ({ value: year, label: year })), [
    date,
    getYears,
  ]);

  const classes = useStyles();

  return (
    <div className={classes.root} ref={ref}>
      <Select
        options={monthOptions}
        value={monthOptions.find((option) => option.value === date.getMonth())}
        onChange={handleSelectChange('month')}
        styles={{
          container: (provided) => ({ ...provided, width: 120 }),
          singleValue: (provided) => ({ ...provided, maxWidth: '100%' }),
          valueContainer: (provided) => ({ ...provided, marginRight: 0 }),
        }}
        maxMenuHeight={200}
      />
      <Select
        options={yearOptions}
        value={yearOptions.find((option) => option.value === date.getFullYear())}
        onChange={handleSelectChange('year')}
        styles={{
          container: (provided) => ({ ...provided, width: 88 }),
          singleValue: (provided) => ({ ...provided, maxWidth: '100%' }),
          valueContainer: (provided) => ({ ...provided, marginRight: 0 }),
        }}
        maxMenuHeight={200}
      />
    </div>
  );
});

CaptionSelect.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  localeUtils: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  getYears: PropTypes.func,
};

CaptionSelect.defaultProps = {
  getYears: undefined,
};

export default CaptionSelect;
